// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-link{display:block;height:30px;margin-right:40px;width:123px}.home-link>svg{height:100%}@media only screen and (max-width: 960px){.home-link{margin-right:26px;width:24px;overflow:hidden}}", ""]);
// Exports
module.exports = exports;
